export const SEX = {
  undefined: 'undefined',
  male: 'male',
  female: 'female',
  other: 'other',
};

export const sexData = {
  [SEX.male]: {
    label: 'Male',
    value: SEX.male,
    icon: 'mars',
  },
  [SEX.female]: {
    label: 'Female',
    value: SEX.female,
    icon: 'venus',
  },
  /* [SEX.other]: {
    label: 'Other',
    value: SEX.other,
    icon: 'transgender',
  }, */
};

export const getSexDate = (sex) => {
  if (!sexData[sex]) {
    return {};
  }
  return sexData[sex];
};
